__turbopack_context__.v({
  "article": "AuthorBio-module__cq9SQq__article",
  "authorBio": "AuthorBio-module__cq9SQq__authorBio",
  "bioContent": "AuthorBio-module__cq9SQq__bioContent",
  "contact": "AuthorBio-module__cq9SQq__contact",
  "header": "AuthorBio-module__cq9SQq__header",
  "name": "AuthorBio-module__cq9SQq__name",
  "role": "AuthorBio-module__cq9SQq__role",
  "tagline": "AuthorBio-module__cq9SQq__tagline",
});
